import http from '@core/fetch'
export default {
  //新建档期
  createCalenderItem: params =>
    http.post(
      '/p/wedding/index.php/Admin/APIMerchantCalender/createCalenderItem',
      {
        body: params,
        method: 'POST'
      }
    ),
  //编辑档期
  updateCalenderItem: params =>
    http.post(
      '/p/wedding/index.php/Admin/APIMerchantCalender/updateCalenderItem',
      {
        body: params,
        method: 'POST'
      }
    ),
  //获取日历模式宴会厅档期列表
  getAllCalendarMode: params =>
    http('/p/wedding/index.php/Admin/APIMerchantCalender/cal_hotel_all', {
      body: params
    }),
  //当天列表数据
  getListMode: params =>
    http('/p/wedding/index.php/Admin/APIMerchantCalenderItem/all_list_hotel', {
      body: params
    }),
  //删除档期
  delCalenderItem: params =>
    http('/p/wedding/index.php/Admin/APIMerchantCalender/delCalenderItem', {
      body: params
    }),
  //宴会厅列表
  getHotelHalls: () =>
    http('/p/wedding/index.php/Admin/APIMerchantCalenderItem/hotel_halls'),
  //获取商家信息
  getMerchantInfo: () => http('/p/wedding/index.php/Admin/APIMerchant/edit')
}
